var _rect, _rect2, _rect3, _rect4, _path, _path2, _path3, _path4, _rect5, _path5, _path6, _path7, _path8, _rect6, _path9, _path0, _path1, _path10, _rect7, _path11, _path12, _path13, _path14, _rect8, _rect9, _path15, _path16, _path17, _path18;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCon3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 153,
    viewBox: "0 0 153 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 87,
    y: 33,
    width: 33,
    height: 39,
    rx: 4,
    fill: "#B1A184"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 82,
    width: 33,
    height: 39,
    rx: 4,
    fill: "#B1A184"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 87,
    y: 83,
    width: 33,
    height: 39,
    rx: 4,
    fill: "#B1A184"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 30,
    width: 33,
    height: 39,
    rx: 4,
    fill: "#EFCC90"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90 37H110",
    stroke: "#BC9675",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M90 45H110",
    stroke: "#BC9675",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M90 61H110",
    stroke: "#BC9675",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M90 53H110",
    stroke: "#BC9675",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 79,
    width: 33,
    height: 39,
    rx: 4,
    fill: "#EFCC90"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39 86H59",
    stroke: "#BC9675",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39 94H59",
    stroke: "#BC9675",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39 110H59",
    stroke: "#BC9675",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M39 102H59",
    stroke: "#BC9675",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 80,
    width: 33,
    height: 39,
    rx: 4,
    fill: "#EFCC90"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M90 87H110",
    stroke: "#BC9675",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M90 95H110",
    stroke: "#BC9675",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M90 111H110",
    stroke: "#BC9675",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M90 103H110",
    stroke: "#BC9675",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 30,
    width: 33,
    height: 39,
    rx: 4,
    fill: "#EFCC90"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M39 37H59",
    stroke: "#BC9675",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M39 45H59",
    stroke: "#BC9675",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M39 61H59",
    stroke: "#BC9675",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M39 53H59",
    stroke: "#BC9675",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 33,
    width: 33,
    height: 39,
    rx: 4,
    fill: "#B1A184"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 30,
    width: 33,
    height: 39,
    rx: 4,
    fill: "#EFCC90"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M39 37H59",
    stroke: "#BC9675",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M39 45H59",
    stroke: "#BC9675",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M39 61H59",
    stroke: "#BC9675",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M39 53H59",
    stroke: "#BC9675",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCon3);
export default __webpack_public_path__ + "static/media/con-3.181039044c91ffd8dbb30b681bafd152.svg";
export { ForwardRef as ReactComponent };